<template>
    <div>
        <app-title text="Tareas por resolver" />
        <app-task-filters @filter="onFilter" @clean="resetFilters" />
        <app-assigned-tasks-list
            :data="tasks"
            :on-change-page="onChangePage"
            @create-note="startCreateNote"
            @see-notes="seeNotes"
            @upload-files="startUploadFiles"
            @solve-task="startSolveTask"
            @sort="onSort"
        />

        <!-- INICIO popUp's -->
        <app-pop-up
            title="Agregar nota de la tarea"
            id="add-note-task-assigned"
            :onClose="cleanNoteForm"
        >
            <div slot="body">
                <app-add-note-task
                    v-if="selectedTask"
                    id="add-note-task-assigned"
                    :task="selectedTask"
                    :on-save="onSaveNote"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="saveNote"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Subir archivos a la tarea"
            id="tasks-files"
            :onClose="cleanFiles"
        >
            <div class="body" slot="body">
                <app-upload-files
                    id="tasks-files"
                    title="Adjunte archivos relacionados a la solución de la tarea"
                    v-model="taskFiles.files"
                ></app-upload-files>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="uploadFiles(taskFiles)"
                    :disabled="inProgress"
                >
                    Subir
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Finalización de tarea"
            id="mark-resolved-task"
            :onClose="cleanMarkResolved"
        >
            <div class="body" slot="body">
                <div v-if="canBeSolved">
                    <h5>
                        ¿Esta seguro que desea marcar como resuelta esta tarea?
                    </h5>
                </div>
                <div v-else>
                    <h5>
                        No puede marcar como resuelta esta tarea, debe subir al
                        menos un archivo con la solución
                    </h5>
                </div>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    v-if="canBeSolved"
                    @click="resolvePetition(selectedTask)"
                >
                    <i class="fa fa-check"></i> Marcar como resuelta
                </button>
            </div>
        </app-pop-up>
        <!-- FIN popUp's -->
    </div>
</template>
<script>
import AssignedTasksList from "./AssignedTasksList/AssignedTasksList.vue";
import tasksRepository from "../../../../repositories/tasks.repository.js";
import NotesTask from "../NotesTask/NotesTaskList/NotesTask.vue";
import AddNoteTask from "../NotesTask/AddNoteTask/AddNoteTask.vue";
import UploadFiles from "../../../UI/Controls/Files/UploadFiles.vue";
import TaskFilters from "../AssignmentTask/AssignmentTaskFilters/AssignmentTaskFilters";
export default {
    components: {
        appAssignedTasksList: AssignedTasksList,
        appNotesTask: NotesTask,
        appAddNoteTask: AddNoteTask,
        appUploadFiles: UploadFiles,
        appTaskFilters: TaskFilters
    },

    data() {
        return {
            tasks: {},
            page: 1,
            selectedTask: "",
            taskFiles: {
                files: "",
                userId: "",
                taskId: ""
            },
            filters: null,
            canBeSolved: false,
            sort: {
                sortBy: "due_date",
                sortDir: "asc"
            }
        };
    },

    methods: {
        loadAssignedTasks() {
            const tr = Object.assign({}, tasksRepository);
            const payload = {
                ...this.filters,
                status: "to-solve",
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir
            };
            tr.getTasksByAssigned(this.user.id, payload, this.page)
                .then(data => {
                    const tasks = data.data;
                    const fTasks = tasks.map(item => ({
                        ...item,
                        _rowVariant: moment().isAfter(moment(item.due_date))
                            ? "ignore overdue"
                            : ""
                    }));
                    const theData = { ...data, data: fTasks };
                    this.tasks = theData;
                })
                .catch(error =>
                    toastr.error("Error al cargar las tareas del usuario")
                );
        },
        onChangePage(page) {
            this.page = page;
            this.loadAssignedTasks();
        },
        onFilter(filters) {
            this.filters = filters;
            this.loadAssignedTasks();
        },
        resetFilters(filters) {
            this.filters = null;
            this.loadAssignedTasks();
        },
        startCreateNote(task) {
            this.selectedTask = task;
            this.$bus.$emit("add-note-task-assigned.open");
        },
        saveNote() {
            this.$bus.$emit("add-note-task-assigned.save");
        },
        onSaveNote() {
            this.$bus.$emit("add-note-task-assigned.close");
            this.loadAssignedTasks();
        },
        cleanNoteForm() {
            this.$bus.$emit("add-note-task-assigned.clean");
        },
        seeNotes(task) {
            this.selectedTask = task;
            this.$bus.$emit("notes-task-assigned.open");
        },
        startUploadFiles(task) {
            this.taskFiles.userId = this.user.id;
            this.taskFiles.taskId = task.id;
            this.$bus.$emit("tasks-files.open");
        },
        uploadFiles(task) {
            const formData = new FormData();

            formData.append("taskId", this.taskFiles.taskId);
            //userid para la creación del log
            formData.append("userId", this.taskFiles.userId);
            //userid para la subida y cracion de archivos a s3
            formData.append("creatorId", this.taskFiles.userId);

            if (this.taskFiles.files.files) {
                this.taskFiles.files.files.map((item, index) =>
                    formData.append("file" + index, item)
                );
            }
            const tr = Object.assign({}, tasksRepository);
            tr.uploadFiles(formData)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadAssignedTasks();
                        this.$bus.$emit("tasks-files.close");
                        this.cleanFiles();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error(
                        "No se pudieron subir los archivos al sistema"
                    );
                });
        },
        cleanFiles() {
            this.$bus.$emit("tasks-files.clean");
        },
        startSolveTask(task) {
            if (task.require_files) {
                this.selectedTask = task;
                this.canBeSolved = this.itsTaskResolved(task);
                this.$bus.$emit("mark-resolved-task.open");
            } else {
                this.canBeSolved = true;
                this.selectedTask = task;
                this.$bus.$emit("mark-resolved-task.open");
            }
        },
        resolvePetition() {
            const formData = new FormData();
            formData.append("userId", this.user.id);

            const tr = Object.assign({}, tasksRepository);

            tr.markResolvedTask(this.selectedTask.id, formData)
                .then(data => {
                    if (data.status) {
                        this.selectedTask = {};
                        this.$bus.$emit("mark-resolved-task.close");
                        this.loadAssignedTasks();
                        this.$bus.$emit("loadNotifications");
                        toastr.success(data.msg);
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("No fue posible aprobar la petición");
                });
        },
        itsTaskResolved(task) {
            if (task.files.length) {
                const val = task.files.filter(
                    item => item.user_id === this.user.id
                );
                return !!val.length;
            } else {
                return false;
            }
        },
        cleanMarkResolved() {
            this.selectedTask = {};
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadAssignedTasks();
        },
        deleteComment(payload) {
            const task = this.tasks.data.find(
                task => task.id === payload.taskId
            );

            if (!task) return;

            task.detailsShowing = true;

            task.notes = task.notes.filter(note => note.id !== payload.noteId);
        }
    },

    created() {
        this.loadAssignedTasks();

        this.$bus.$on("task-note.delete", this.deleteComment);
    }
};
</script>
